<template>
  <div class="otherInfo">
    <OACard>
      <el-tabs v-model="type" type="card">
        <el-tab-pane label="劳动合同" name="Contract">
          <d2-crud
            ref="contract"
            :columns="contractColumns"
            :data="contractTable"
            :options="options"
          />
        </el-tab-pane>
        <el-tab-pane label="家庭成员" name="Family">
          <d2-crud ref="family" :columns="familyColumns" :data="familyTable" :options="options"/>
        </el-tab-pane>
        <el-tab-pane label="教育信息" name="Educate">
          <d2-crud ref="educate" :columns="educateColumns" :data="educateTable" :options="options"/>
        </el-tab-pane>
        <el-tab-pane label="工作经历" name="Work">
          <d2-crud ref="work" :columns="workColumns" :data="workTable" :options="options"/>
        </el-tab-pane>
      </el-tabs>
    </OACard>
  </div>
</template>
<script>
import api from "@/services/otherTable.js";
import columns from "./columns.js";
import d2Crud from "@d2-projects/d2-crud";
import OACard from "@/components/OACard/OACard";

export default {
  name: "otherInfo",
  props: {
    userId: {
      default: null
    }
  },
  components: { d2Crud,OACard },
  data() {
    return {
      options: {
        border: true,
        stripe: true,
        size: "medium"
      },
      contractColumns: columns.contractColumns,
      familyColumns: columns.familyColumns,
      educateColumns: columns.educateColumns,
      workColumns: columns.workColumns,
      evaluateColumns: columns.evaluateColumns,
      contractTable: [], //劳动合同
      familyTable: [], //家庭成员
      educateTable: [], //教育信息
      workTable: [], //工作信息
      evaluateTable: [], //面试评价
      type: "Contract",
      type2: "Evaluate"
    };
  },
  watch: {
    userId: {
      handler: function(val, oldVal) {
        if (val) {
          this.getEducate();
          this.getFamily();
          this.getWork();
          this.getContract();
          this.getEvaluate();
        }
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    async getEducate() {
      let res = await api.getEducate({ id: this.userId });
      this.educateTable = res.data.data;
    },
    async getFamily() {
      let res = await api.getFamily({ id: this.userId });
      this.familyTable = res.data.data;
    },
    async getWork() {
      let res = await api.getWork({ id: this.userId });
      this.workTable = res.data.data;
    },
    async getContract() {
      let res = await api.getContract({ id: this.userId });
      this.contractTable = res.data.data;
    },
    async getEvaluate() {
      let res = await api.getEvaluate({ id: this.userId });
      this.evaluateTable = res.data.data;
    }
  }
};
</script>
<style lang="scss">
.otherInfo {
  .el-tabs--card > .el-tabs__header {
    border-bottom: none;
  }
  .el-tabs__header {
    margin: 0px;
  }
  .el-tabs__content .d2-crud .d2-crud-body {
    padding: 0px;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/otherTable/otherInfo.vue